// Lo que el propietario dijo, en sus palabras: la lista de descripciones
// que pinta la «Evidencia inicial» de la card (README §1, párrafo de la
// derecha). Un core-api anterior a `ownerDescriptions` no la manda: cae
// al texto de la observación cuando la levantó el propietario, y a la
// transcripción de la nota de voz si ninguna descripción la repite.
//
// Una descripción retirada (Ley 21.719) llega con `redacted: true` y
// `text: null`; se conserva en la lista para que el cliente muestre el
// aviso, nunca se rellena con otro campo.
//
// ADR-0163 — una consulta convertida (`consulta_propietario`) usa SÓLO
// `ownerDescriptions`: su `humanDescription` es el texto que el jefe
// escribió para el contratista, nunca las palabras del propietario.

import type { FindingDetailResponse, OwnerDescription } from "@bitacorapro/api-types";

type Obs = Pick<
  FindingDetailResponse["observation"],
  "ownerDescriptions" | "humanDescription" | "origen" | "audioTranscript"
>;

export function descripcionesDe(o: Obs): OwnerDescription[] {
  const base: OwnerDescription[] =
    o.ownerDescriptions ??
    (o.humanDescription && o.origen === "reporte_propietario"
      ? [{ kind: null, text: o.humanDescription, redacted: false }]
      : []);
  const transcript = o.audioTranscript;
  if (transcript && base.every((d) => d.text !== transcript)) {
    return [...base, { kind: "dictada", text: transcript, redacted: false }];
  }
  return base;
}
